import { AxiosRequestConfig } from 'axios';
import axios from './axios';

/**
 * useAxios 是对axios做的一层包装 直接返回页面代码需要使用的数据结构 不需要手动解析
 * 请求的拦截在axios.ts文件里判断 该文件不做任何逻辑判断
 * 例：正常请求 const res = useAxios.get<TableRow>(); res类型为TableRow
 * 例：当backResponse === true时 const res = useAxios.get<AxiosResponseData<TableRow>>();
 *     res类型为AxiosResponseData<TableRow>，包含code、data、message等 让页面自己处理此次响应
 *
 * 特别注意：现在所有请求都不加载loading，loading的体验不太友好。你应该在页面自己做骨架屏、局部loading等。
 */

export function useAxios<T = any>(config: AxiosRequestConfig): Promise<T> {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.request<T, AxiosResponseData<T>, any>(config);
      let isCheck = config && config.isCheck;
      if (typeof isCheck !== 'boolean') isCheck = true;
      resolve((isCheck ? res.data : res) as T);
    } catch (error) {
      reject(error);
    }
  });
}
useAxios.get = function <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get<T, AxiosResponseData<T>, any>(url, config);
      let isCheck = config && config.isCheck;
      if (typeof isCheck !== 'boolean') isCheck = true;
      resolve((isCheck ? res.data : res) as T);
    } catch (error) {
      reject(error);
    }
  });
};
useAxios.post = function <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post<T, AxiosResponseData<T>, any>(url, data, config);
      let isCheck = config && config.isCheck;
      if (typeof isCheck !== 'boolean') isCheck = true;
      resolve((isCheck ? res.data : res) as T);
    } catch (error) {
      reject(error);
    }
  });
};
useAxios.delete = function <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.delete<T, AxiosResponseData<T>, any>(url, config);
      let isCheck = config && config.isCheck;
      if (typeof isCheck !== 'boolean') isCheck = true;
      resolve((isCheck ? res.data : res) as T);
    } catch (error) {
      reject(error);
    }
  });
};
useAxios.put = function <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put<T, AxiosResponseData<T>, any>(url, config);
      let isCheck = config && config.isCheck;
      if (typeof isCheck !== 'boolean') isCheck = true;
      resolve((isCheck ? res.data : res) as T);
    } catch (error) {
      reject(error);
    }
  });
};
export default useAxios;
